var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_206_3640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1 7.01697C9.97692 7.32407 9.3 8.18585 9.3 9C9.3 9.81415 9.97692 10.6759 11.1 10.983V7.01697Z",
    fill: "#A8B1BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9 13.017V16.983C14.0231 16.6759 14.7 15.8142 14.7 15C14.7 14.1859 14.0231 13.3241 12.9 13.017Z",
    fill: "#A8B1BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM12 3.9C12.4971 3.9 12.9 4.30294 12.9 4.8V5.18008C14.8565 5.5304 16.5 7.00033 16.5 9C16.5 9.49706 16.0971 9.9 15.6 9.9C15.1029 9.9 14.7 9.49706 14.7 9C14.7 8.18585 14.0231 7.32407 12.9 7.01697V11.1801C14.8565 11.5304 16.5 13.0003 16.5 15C16.5 16.9997 14.8565 18.4696 12.9 18.8199V19.2C12.9 19.6971 12.4971 20.1 12 20.1C11.5029 20.1 11.1 19.6971 11.1 19.2V18.8199C9.14348 18.4696 7.5 16.9997 7.5 15C7.5 14.5029 7.90294 14.1 8.4 14.1C8.89706 14.1 9.3 14.5029 9.3 15C9.3 15.8142 9.97692 16.6759 11.1 16.983V12.8199C9.14348 12.4696 7.5 10.9997 7.5 9C7.5 7.00033 9.14348 5.5304 11.1 5.18008V4.8C11.1 4.30294 11.5029 3.9 12 3.9Z",
    fill: "#A8B1BE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_206_3640"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsd);
export default __webpack_public_path__ + "static/media/USD.6b06dd915ceb51b71cd14e793b700072.svg";
export { ForwardRef as ReactComponent };